import React from 'react';
import {renderTextWithLine} from "../functions/renderTextWithLine";

const OpsText = ({
                     content,
                     className = "",
                     color = "color-g-1",
                     weight = 400,
                     alignment = "center",
                     type = "normal",
                     renderWithLine = true,
                     background = "",
                     lineThrough = false,
                     onClick = null,
                     nowrap = false,
                     textEllipsis = false
                 }) => {
    return (
        <span className={`
                    txt-${type}
                    color-g-1 
                    fa-text-${alignment} 
                    font-${weight} 
                    ${color} 
                    ${background}
                    ${lineThrough && ' text-decoration-line-through'}
                    ${nowrap && 'no-wrap'}
                    ${textEllipsis && 'text-ellipsis'}
                    ${className}
        `} onClick={onClick}>
            {renderWithLine ? renderTextWithLine(content) : content}
        </span>
    );
};

export default OpsText;